export default __webpack_public_path__ + "static/media/anthe-map.6d8b9049.png";